import React, { useEffect, useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import useIntls from '@opm/hooks/useIntls';
import SvgIcon from '@home/components/SvgIcon';
import MemeInfo from '@opm/pages/Memes/Details/component/MemeInfo';
import MemeTrend from '@opm/pages/Memes/Details/component/MemeTrend';
import MemeLangDistribution from '@opm/pages/Memes/Details/component/MemeLangDistribution';
import { useMemeDetails } from '@opm/pages/Memes/hooks';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import './index.scss';
import RelatedVideos from '../Details/component/RelatedVideos';

interface IMemeDrawerProps {
  visible: boolean;
  record: any;
  filter: any;
  onClose: () => void;
  onGoToDetail: (record: any, type: string) => void;
}

export default function MemeDrawer(props: IMemeDrawerProps) {
  const { visible, record, filter, onClose, onGoToDetail } = props;
  const { isEn } = useIntls();

  const title = isEn ? record?.title : record?.title_zh || record?.title;

  const drawerFilter = useMemo(() => {
    if (!visible || !record?.meme_id) return undefined;
    return {
      ...filter,
      meme_title: record.meme_id,
    };
  }, [visible, record?.meme_id, filter]);

  const { data: detailData, loading: detailLoading } = useMemeDetails({
    filter: drawerFilter,
  });

  useEffect(() => {
    if (visible && record?.meme_id) {
      DBOM_POINT.btn('meme_drawer_open', {
        meme_id: record.meme_id,
        meme_name: title,
      });
    }
  }, [visible, record?.meme_id]);

  if (!record) return null;

  return (
    <CardCommon
      className="dbom-meme-drawer"
      title={title}
      hasDownload
      downloadIcon="clonse"
      downLoadTips="Close"
      handleDownloadOnClick={onClose}
    >
      <div className="dbom-meme-drawer-body">
        {/* Reuse MemeInfo in compact/vertical mode */}
        <MemeInfo
          data={detailData}
          loading={detailLoading}
          compact
          onGoToDetail={() => onGoToDetail(record, "drawer")}
        />

        {/* Meme Trend — reuse MemeTrend component in compact mode */}
        <MemeTrend filter={drawerFilter} compact />

        {/* Language Distribution — reuse MemeLangDistribution in compact mode */}
        <MemeLangDistribution filter={drawerFilter} compact />

        {/* AI Brainstorming — reuse component */}
        {/* <AiBrainstormBtn className="dbom-meme-drawer-brainstorm" /> */}

        {/* Related Videos — reuse component */}
        <RelatedVideos
          videos={detailData?.related_videos || []}
          maxCount={4}
          className="dbom-meme-drawer-related"
        />
      </div>
    </CardCommon>
  );
}
